import { render } from "./PopoverLink.vue?vue&type=template&id=4b4da1a9&ts=true"
import script from "./PopoverLink.vue?vue&type=script&lang=ts"
export * from "./PopoverLink.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__